import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Tip } from '../../../shared/models/step.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgClass } from '@angular/common';


@Component({
  selector: 'direct-random-facts',
  template:`
    
    <div class=" "
    [ngClass]="{'hidden-content': factForStep.tipString === 'No tips available for this step'}"
    >
      <div class="direct-random-facts__container__bottom">
        <img class="material-icons" style="fill: white;" src="assets/Icons/{{factForStep.tipIconValue}}.svg">
        {{ factForStep.tipString }}
      </div>
      <div class="tip-ref">   
        <a  style="color: white; font-size: small; text-decoration: none;" 
          href="{{this.urlLinkForTipSource}}" 
          target="_blank">{{factForStep.tipSource}}
        </a>
      </div>
    </div>

  `,
  styleUrls: ['./direct-random-facts.component.scss'],
  host: {'class': 'direct-random-facts'},
  standalone: true,
  imports: [NgClass]
})

export class DirectRandomFactsComponent implements OnInit {
  private unsubscriber = new Subject<void>();

  private readonly TIPS: Tip[] = [
    {
      tipString: "Consumers lost an estimated $47 billion to identity fraud and scams.",
      tipIconValue: "currency-dollar",
      tipSource: "Javelin 2025 Identity Fraud Study (March 2025)",
      tipSourceUrl: "https://javelinstrategy.com"
    },
    {
      tipString: "65% of financial institutions reported an increase in fraud activity during 2024.",
      tipIconValue: "exclamation-circle",
      tipSource: "",
      tipSourceUrl: ""
    },
    {
      tipString: "AI-driven scams are projected to cause up to $40 billion in losses by 2027.",
      tipIconValue: "exclamation-circle",
      tipSource: "",
      tipSourceUrl: ""
    },
    {
      tipString: "60% of U.S. credit cardholders have experienced credit card fraud.",
      tipIconValue: "currency-dollar",
      tipSource: "",
      tipSourceUrl: ""
    },
    {
      tipString: "More than 26 billion personal records have been found on the dark web.",
      tipIconValue: "users",
      tipSource: "Experian 2024 U.S. Identity & Fraud Report",
      tipSourceUrl: "https://experian.com"
    }
  ];

  stateChange: boolean = false;
  isHandsetPortrait: boolean = false;

  factForStep: Tip = this.TIPS[0];

  urlLinkForTipSource: URL = new URL("https://www.google.com");

  constructor(
    private readonly responsive: BreakpointObserver,
    public directSessionLogic: DirectSessionLogicService,
    private readonly router: Router
  ){
    this.router.events.subscribe(event =>{
      if(event instanceof NavigationEnd){
        this.getFactsOnNavEnd( event.urlAfterRedirects );
      }
    })
  }

  ngOnInit():void {
    this.responsive.observe(Breakpoints.HandsetPortrait).subscribe(result => {
      this.isHandsetPortrait = false;
      if (result.matches) {
        this.isHandsetPortrait = true;
      }
    });
  }

  getFactsOnNavEnd(urlAfterRedirects: string){
    const tip = this.TIPS[Math.floor(Math.random() * this.TIPS.length)];
    this.factForStep = tip;
    if(tip.tipSourceUrl) {
      try { this.urlLinkForTipSource = new URL(tip.tipSourceUrl); } catch { }
    }
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
